import "./actor.cb50ae3a.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6TXE3 = parcelRequire("6TXE3");
var $ee6da8756cfb7581$exports = {};
$ee6da8756cfb7581$exports = import.meta.resolve("5hJzY");


const $646e598f9dc81824$var$game = new $6TXE3.Engine({
    width: 600,
    height: 400,
    pixelArt: true,
    displayMode: $6TXE3.DisplayMode.FitScreen
});
// start-snippet{spritesheet}
const $646e598f9dc81824$var$kennyCardsImage = new $6TXE3.ImageSource((0, (/*@__PURE__*/$parcel$interopDefault($ee6da8756cfb7581$exports))));
const $646e598f9dc81824$var$spriteSheet = $6TXE3.SpriteSheet.fromImageSource({
    image: $646e598f9dc81824$var$kennyCardsImage,
    grid: {
        rows: 4,
        columns: 14,
        spriteWidth: 42,
        spriteHeight: 60
    },
    spacing: {
        // Optionally specify the offset from the top left of sheet to start parsing
        originOffset: {
            x: 11,
            y: 2
        },
        // Optionally specify the margin between each sprite
        margin: {
            x: 23,
            y: 5
        }
    }
});
var $646e598f9dc81824$var$Suit = /*#__PURE__*/ function(Suit) {
    Suit[Suit["Hearts"] = 0] = "Hearts";
    Suit[Suit["Diamonds"] = 1] = "Diamonds";
    Suit[Suit["Clubs"] = 2] = "Clubs";
    Suit[Suit["Spades"] = 3] = "Spades";
    return Suit;
}($646e598f9dc81824$var$Suit || {});
var $646e598f9dc81824$var$Rank = /*#__PURE__*/ function(Rank) {
    Rank[Rank["Ace"] = 0] = "Ace";
    Rank[Rank["Two"] = 1] = "Two";
    Rank[Rank["Three"] = 2] = "Three";
    Rank[Rank["Four"] = 3] = "Four";
    Rank[Rank["Five"] = 4] = "Five";
    Rank[Rank["Six"] = 5] = "Six";
    Rank[Rank["Seven"] = 6] = "Seven";
    Rank[Rank["Eight"] = 7] = "Eight";
    Rank[Rank["Nine"] = 8] = "Nine";
    Rank[Rank["Ten"] = 9] = "Ten";
    Rank[Rank["Jack"] = 10] = "Jack";
    Rank[Rank["Queen"] = 11] = "Queen";
    Rank[Rank["King"] = 12] = "King";
    return Rank;
}($646e598f9dc81824$var$Rank || {});
// end-snippet{spritesheet}
const $646e598f9dc81824$var$animation = new $6TXE3.Animation({
    frames: $646e598f9dc81824$var$spriteSheet.sprites.map((s)=>({
            graphic: s,
            duration: 300
        })),
    strategy: $6TXE3.AnimationStrategy.PingPong
});
const $646e598f9dc81824$var$actor = new $6TXE3.Actor({
    pos: $6TXE3.vec($646e598f9dc81824$var$game.halfDrawWidth, $646e598f9dc81824$var$game.halfDrawHeight),
    scale: $6TXE3.vec(2, 2)
});
$646e598f9dc81824$var$actor.graphics.use($646e598f9dc81824$var$animation);
$646e598f9dc81824$var$game.currentScene.onPostDraw = (ctx)=>{
    $646e598f9dc81824$var$spriteSheet.getSprite(9, 3).draw(ctx, $646e598f9dc81824$var$actor.pos.x + 100, $646e598f9dc81824$var$actor.pos.y);
    $646e598f9dc81824$var$spriteSheet.getSprite(9, 0).draw(ctx, $646e598f9dc81824$var$actor.pos.x - 100, $646e598f9dc81824$var$actor.pos.y);
};
const $646e598f9dc81824$var$loader = new $6TXE3.Loader([
    $646e598f9dc81824$var$kennyCardsImage
]);
$646e598f9dc81824$var$game.start($646e598f9dc81824$var$loader).then(()=>{
    $646e598f9dc81824$var$game.currentScene.add($646e598f9dc81824$var$actor);
});


//# sourceMappingURL=spritesheet.f3a7cec4.js.map
